const ALLOWED_MIME = new Set(['image/png', 'image/jpeg', 'image/webp', 'image/gif']);
const ALLOWED_EXT = new Set(['png', 'jpg', 'jpeg', 'webp', 'gif']);

export type ClipboardImageSource = {
  files?: ArrayLike<File> | null;
  items?: ArrayLike<{
    kind: string;
    type: string;
    getAsFile: () => File | null;
  }> | null;
};

function fileExtension(name: string): string {
  const parts = String(name || '').split('.');
  return parts.length > 1 ? String(parts.pop() || '').toLowerCase() : '';
}

export function isAllowedLocalImageFile(file: Pick<File, 'name' | 'type'>): boolean {
  const mime = String(file.type || '').toLowerCase();
  if (ALLOWED_MIME.has(mime)) return true;
  return ALLOWED_EXT.has(fileExtension(file.name));
}

function imagePreference(file: Pick<File, 'name' | 'type'>): number {
  const mime = String(file.type || '').toLowerCase();
  if (mime === 'image/png' || fileExtension(file.name) === 'png') return 0;
  return 1;
}

function collectFiles(source: ClipboardImageSource): File[] {
  const found: File[] = [];
  if (source.files) {
    for (let index = 0; index < source.files.length; index += 1) {
      const file = source.files[index];
      if (file && isAllowedLocalImageFile(file)) found.push(file);
    }
  }
  if (source.items) {
    for (let index = 0; index < source.items.length; index += 1) {
      const item = source.items[index];
      if (item.kind !== 'file') continue;
      const file = item.getAsFile();
      if (file && isAllowedLocalImageFile(file)) found.push(file);
    }
  }
  return found;
}

export function clipboardHasFilePayload(source: ClipboardImageSource): boolean {
  if (source.files && source.files.length > 0) return true;
  if (!source.items) return false;
  for (let index = 0; index < source.items.length; index += 1) {
    if (source.items[index].kind === 'file') return true;
  }
  return false;
}

export function readClipboardImageFile(source: ClipboardImageSource | null | undefined): File | null {
  if (!source) return null;
  const files = collectFiles(source);
  if (!files.length) return null;
  return files.slice().sort((left, right) => imagePreference(left) - imagePreference(right))[0] || null;
}
